import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { Field, Fields, reduxForm, SubmissionError, getFormValues } from 'redux-form';

import Button from 'components/common/Button';
import TextField from 'components/fields/TextField';
import CheckboxButtonField from 'components/fields/CheckboxButtonField';
import MultiselectAutosuggestField from 'components/fields/MultiselectAutosuggestField';
import FormLabel from '@material-ui/core/FormLabel';
import FormError from 'components/common/FormError';
import Tooltip from 'components/common/Tooltip';
import IconInfo from 'components/icons/IconInfo';

import objectDiff from 'utils/objectDiff';

import {
  createPatientNote,
  updatePatientNote,
  addPatientNoteResource,
  removePatientNoteResource,
} from 'redux/modules/patientsNotes';
import {
  createOrderNote,
  updateOrderNote,
  addOrderNoteResource,
  removeOrderNoteResource,
} from 'redux/modules/ordersNotes';

import {
  requestSearchNoteCategories,
} from 'redux/modules/noteCategories';
import { accountLoginFail } from 'redux/modules/account';

const styles = theme => ({
  buttons: {
    marginTop: 20,
  },
  buttonsCreate: {
    textAlign: 'right',
    marginTop: 0,
  },
  button: {
    '& + $button': {
      marginLeft: 20,
    },
  },
  formError: {
    marginBottom: 16,
  },
  checkboxField: {
    marginBottom: 8,
  },
  iconInfo: {
    display: 'block',
    width: 14,
    height: 14,
    color: theme.palette.grey[600],
  },
  tooltip: {
    margin: '0 0 -3px 4px',
  },
  buttonSubmitCreate: {
    marginTop: 8,
  },
});

function onChange(values, dispatch, props, prevValues) {
  if (values['Selected Notes Category']) {
    if (!values['Notes Category']
      || values['Notes Category'].findIndex(item =>
        item.value === values['Selected Notes Category'].value) === -1) {
      props.array.push('Notes Category', values['Selected Notes Category']);
    }
    props.clearFields(false, false, 'Selected Notes Category');
  }

  if (values.Intake && !prevValues.Intake) {
    if (values.Delivery) {
      dispatch(props.change('Delivery', false));
    }
    if (values.Billing) {
      dispatch(props.change('Billing', false));
    }
    if (values.Collection) {
      dispatch(props.change('Collection', false));
    }
    if (values.Paid) {
      dispatch(props.change('Paid', false));
    }
    if (values.General) {
      dispatch(props.change('General', false));
    }
  }

  if (values.Delivery && !prevValues.Delivery) {
    if (values.Intake) {
      dispatch(props.change('Intake', false));
    }
    if (values.Billing) {
      dispatch(props.change('Billing', false));
    }
    if (values.Collection) {
      dispatch(props.change('Collection', false));
    }
    if (values.Paid) {
      dispatch(props.change('Paid', false));
    }
    if (values.General) {
      dispatch(props.change('General', false));
    }
  }

  if (values.Billing && !prevValues.Billing) {
    if (values.Intake) {
      dispatch(props.change('Intake', false));
    }
    if (values.Delivery) {
      dispatch(props.change('Delivery', false));
    }
    if (values.Collection) {
      dispatch(props.change('Collection', false));
    }
    if (values.Paid) {
      dispatch(props.change('Paid', false));
    }
    if (values.General) {
      dispatch(props.change('General', false));
    }
  }

  if (values.Collection && !prevValues.Collection) {
    if (values.Intake) {
      dispatch(props.change('Intake', false));
    }
    if (values.Delivery) {
      dispatch(props.change('Delivery', false));
    }
    if (values.Billing) {
      dispatch(props.change('Billing', false));
    }
    if (values.Paid) {
      dispatch(props.change('Paid', false));
    }
    if (values.General) {
      dispatch(props.change('General', false));
    }
  }

  if (values.Paid && !prevValues.Paid) {
    if (values.Intake) {
      dispatch(props.change('Intake', false));
    }
    if (values.Delivery) {
      dispatch(props.change('Delivery', false));
    }
    if (values.Billing) {
      dispatch(props.change('Billing', false));
    }
    if (values.Collection) {
      dispatch(props.change('Collection', false));
    }
    if (values.General) {
      dispatch(props.change('General', false));
    }
  }

  if (values.General && !prevValues.General) {
    if (values.Intake) {
      dispatch(props.change('Intake', false));
    }
    if (values.Delivery) {
      dispatch(props.change('Delivery', false));
    }
    if (values.Billing) {
      dispatch(props.change('Billing', false));
    }
    if (values.Collection) {
      dispatch(props.change('Collection', false));
    }
    if (values.Paid) {
      dispatch(props.change('Paid', false));
    }
  }
}

function onSubmit(values, dispatch, props) {
  const normalizeValues = (formValues) => {
    const normalizedValues = Object.assign({}, formValues, {});

    if (normalizedValues['Notes Category']) {
      delete normalizedValues['Notes Category'];
    }
    delete normalizedValues.Intake;
    delete normalizedValues.Delivery;
    delete normalizedValues.Billing;
    delete normalizedValues.Collection;
    delete normalizedValues.General;
    delete normalizedValues.Paid;

    return normalizedValues;
  };
  if (props.pristine) {
    return Promise.reject();
  }
  if (values.ID) {
    const diffValues = objectDiff(values, props.initialValues);
    const addedNotesCategory = values['Notes Category'].filter(item =>
      props.initialValues['Notes Category'].filter(initialItem => initialItem.value === item.value).length === 0);
    const removedNotesCategory = props.initialValues['Notes Category'].filter(initialItem =>
      values['Notes Category'].filter(item => item.value === initialItem.value).length === 0);
    if (props.variant === 'patient') {
      return new Promise((resolve, reject) => {
        if (diffValues.Text) {
          dispatch(updatePatientNote({
            values: {
              ID: values.ID,
              ...normalizeValues(diffValues),
            },
            resolve,
            reject,
          }));
        } else {
          resolve();
        }
      })
        .then(() => new Promise((resolve, reject) => {
          if (addedNotesCategory.length > 0) {
            dispatch(addPatientNoteResource({
              values: {
                ID: values.ID,
                'Notes Category ID': addedNotesCategory.map(item => item.value),
              },
              resolve,
              reject,
            }));
          } else {
            resolve();
          }
        }))
        .then(() => new Promise((resolve, reject) => {
          if (removedNotesCategory.length > 0) {
            dispatch(removePatientNoteResource({
              values: {
                ID: values.ID,
                'Notes Category ID': removedNotesCategory.map(item => item.value),
              },
              resolve,
              reject,
            }));
          } else {
            resolve();
          }
        }))
        .then(res => res,
          (err) => {
            if (err.error) {
              throw new SubmissionError({ _error: err.error });
            }
            throw new SubmissionError(err);
          });
    }
    return new Promise((resolve, reject) => {
      if (diffValues.Text) {
        dispatch(updateOrderNote({
          values: {
            ID: values.ID,
            ...normalizeValues(diffValues),
          },
          resolve,
          reject,
        }));
      } else {
        resolve();
      }
    })
      .then(() => new Promise((resolve, reject) => {
        if (addedNotesCategory.length > 0) {
          dispatch(addOrderNoteResource({
            values: {
              ID: values.ID,
              'Notes Category ID': addedNotesCategory.map(item => item.value),
            },
            resolve,
            reject,
          }));
        } else {
          resolve();
        }
      }))
      .then(() => new Promise((resolve, reject) => {
        if (removedNotesCategory.length > 0) {
          dispatch(removeOrderNoteResource({
            values: {
              ID: values.ID,
              'Notes Category ID': removedNotesCategory.map(item => item.value),
            },
            resolve,
            reject,
          }));
        } else {
          resolve();
        }
      }))
      .then(res => res,
        (err) => {
          if (err.error) {
            throw new SubmissionError({ _error: err.error });
          }
          throw new SubmissionError(err);
        });
  }
  return new Promise((resolve, reject) => {
    if (props.variant === 'patient') {
      dispatch(createPatientNote({
        values: {
          'User Record Number': props['User Record Number'],
          'Author ID': props['Author ID'],
          ...normalizeValues(values),
          ...values['Notes Category'] && values['Notes Category'].length > 0
            ? { 'Notes Category ID': values['Notes Category'].map(item => item.value) }
            : {},
        },
        resolve,
        reject,
      }));
    } else {
      dispatch(createOrderNote({
        values: {
          'Order ID': props['Order ID'],
          'Author ID': props['Author ID'],
          ...normalizeValues(values),
          ...values['Notes Category'] && values['Notes Category'].length > 0
            ? { 'Notes Category ID': values['Notes Category'].map(item => item.value) }
            : {},
        },
        resolve,
        reject,
      }));
    }
  }).then(res => res,
    (err) => {
      if (err.error) {
        throw new SubmissionError({ _error: err.error });
      }
      throw new SubmissionError(err);
    });
}

function onSubmitSuccess(values, dispatch, props) {
  if (!props.ID) {
    props.reset();
  }
}

const OrderNotesForm = ({
  handleSubmit,
  submit,
  change,
  error,
  initialValues,
  onCancelButtonClick,
  onSubmitButtonBlur,
  inputRef,
  pristine,
  classes,
  actions,
  onSubmitButtonClick,
  theme,
  workflowStateFilter,
  disabled,
}) => (
  <form
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
  >
    {error &&
      <FormError className={classes.formError}>
        {error}
      </FormError>
    }
    <FormLabel
      component="legend"
    >
      Workflow Category
      <Tooltip
        className={classes.tooltip}
        content={
          <Typography variant="subheading" color="secondary">
            To find relevant notes quicker select the department it belong to and assign a category
          </Typography>
        }
        color="grey"
      >
        <IconInfo className={classes.iconInfo} />
      </Tooltip>
    </FormLabel>
    <Grid
      container
      spacing={24}
    >
      <Grid item>
        <Field
          id="Intake"
          name="Intake"
          label="Intake"
          color={theme.palette.states.intake}
          component={CheckboxButtonField}
          size="small"
        />
        <Field
          id="Delivery"
          name="Delivery"
          label="Delivery"
          color={theme.palette.states.delivery}
          component={CheckboxButtonField}
          size="small"
        />
        <Field
          id="Billing"
          name="Billing"
          label="Billing"
          color={theme.palette.states.billing}
          component={CheckboxButtonField}
          size="small"
        />
        <Field
          id="Collection"
          name="Collection"
          label="Collection"
          color={theme.palette.states.collection}
          component={CheckboxButtonField}
          size="small"
        />
        <Field
          id="Paid"
          name="Paid"
          label="Paid"
          color={theme.palette.states.paid}
          component={CheckboxButtonField}
          size="small"
        />
        <Field
          id="General"
          name="General"
          label="General"
          color={theme.palette.states.archive}
          component={CheckboxButtonField}
          size="small"
        />
      </Grid>
    </Grid>
    <Grid
      container
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Fields
          names={[
            'Notes Category Name',
            'Notes Category',
          ]}
          autosuggestFieldName="Notes Category Name"
          fieldArrayName="Notes Category"
          placeholder="-Select Category-"
          component={MultiselectAutosuggestField}
          renderSuggestionContent={suggestion =>
            suggestion.Name}
          renderInputContent={suggestion =>
            suggestion.Name}
          onSuggestionSelected={(suggestion) => {
            change('Selected Notes Category', {
              value: suggestion.ID,
              label: suggestion.Name,
            });
            return '';
          }}
          fetchSuggestions={({ value, limit, offset, fieldArrayValue }) => (
            requestSearchNoteCategories({
                filters: [
                  ...value.length > 0
                    ? [{
                      name: 'Name',
                      operation: 'startswith',
                      val: value,
                      case_sensitivity: false,
                    }] : [],
                  ...fieldArrayValue && fieldArrayValue.length > 0
                    ? fieldArrayValue.map(item => ({
                      name: 'ID',
                      operation: 'ne',
                      val: item.value,
                    }))
                    : [],
                  ...workflowStateFilter && workflowStateFilter.length > 0
                    ? [{name: 'Workflow State ID',
                      operation: 'in',
                      val: workflowStateFilter,
                    }] : [],
                  {
                    name: 'Is Active',
                    operation: 'eq',
                    val: true,
                  },
                ],
                limit,
                offset,
              }).then(res => res.data,
                (err) => {
                  if (err.data.error === 'Need authorisation') {
                    actions.accountLoginFail();
                  }
                  return err;
                })
          )}
          keepOpenAfterSelection
        />
      </Grid>
    </Grid>
    <Grid
      container
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Field
          id="Text"
          name="Text"
          placeholder="Leave your comment (Ctrl + Enter)"
          component={TextField}
          fullWidth
          multiline
          inputRef={inputRef}
          maxLength="1000"
          onKeyDown={(event) => {
            if (event.key === 'Enter' && (event.ctrlKey || event.metaKey)) {
              submit();
            }
          }}
          {...!initialValues.ID ? {
            rows: 3,
          } : {}}
          disabled={disabled}
        />
      </Grid>
    </Grid>
    <div
      className={classNames(classes.buttons, {
        [classes.buttonsCreate]: !initialValues.ID,
      })}
    >
      {initialValues.ID &&
        <Button
          className={classes.button}
          variant="raised"
          onClick={onCancelButtonClick}
        >
          Cancel
        </Button>
      }
      <Button
        className={classNames(classes.button, {
          [classes.buttonSubmitCreate]: !initialValues.ID,
        })}
        variant="raised"
        color="primary"
        onClick={() => {
          if (!pristine) {
            submit();
          } else {
            onSubmitButtonClick();
          }
        }}
        {...!initialValues.ID ? {
          onBlur: onSubmitButtonBlur,
        } : {}}
        disabled={disabled}
      >
        Save
      </Button>
    </div>
  </form>
);

OrderNotesForm.propTypes = {
  variant: PropTypes.oneOf(['patient', 'order']),
  pristine: PropTypes.bool.isRequired,
  onSubmitButtonClick: PropTypes.func,
  handleSubmit: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  error: PropTypes.string,
  onCancelButtonClick: PropTypes.func,
  initialValues: PropTypes.shape({
    ID: PropTypes.number,
  }),
  onSubmitButtonBlur: PropTypes.func,
  inputRef: PropTypes.func,
  actions: PropTypes.shape({
    accountLoginFail: PropTypes.func.isRequired,
  }).isRequired,
  disabled: PropTypes.bool,
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      states: PropTypes.shape({
        intake: PropTypes.string.isRequired,
        delivery: PropTypes.string.isRequired,
        billing: PropTypes.string.isRequired,
        collection: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    buttons: PropTypes.string.isRequired,
    buttonsCreate: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    formError: PropTypes.string.isRequired,
  }).isRequired,
};

OrderNotesForm.defaultProps = {
  onCancelButtonClick: () => {},
  initialValues: {},
  error: null,
  variant: 'patient',
  onSubmitButtonBlur: () => {},
  inputRef: () => {},
  onSubmitButtonClick: () => {},
  disabled: false,
};

const mapStateToProps = (store, ownProps) => {
  const notesFilterValues = getFormValues(ownProps.form)(store);
  const workflowStateFilter = [
    ...notesFilterValues
      && notesFilterValues.Intake ? [1] : [],
    ...notesFilterValues
      && notesFilterValues.Delivery ? [2] : [],
    ...notesFilterValues
      && notesFilterValues.Billing ? [3] : [],
    ...notesFilterValues
      && notesFilterValues.Collection ? [4] : [],
    ...notesFilterValues
      && notesFilterValues.Paid ? [5] : [],
    ...notesFilterValues
      && notesFilterValues.General ? [null] : [],
  ];
  return {
    workflowStateFilter,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ accountLoginFail }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  onSubmit,
  onChange,
  onSubmitSuccess,
})(withStyles(styles, { withTheme: true })(OrderNotesForm)));



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/Notes/NotesForm.js